// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"modalFooter_2voEI","desktopInMobileView":"desktopInMobileView_3r8st","pictures":"pictures_3P9JC","multi":"multi_3mi9t"};